(function () {
  'use strict';
  function initialize(root) {
    root.querySelectorAll('.package-picker').forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      var card = form.closest('.flash-card');
      var select = form.querySelector('select');
      if (!card || !select) return;
      function money(cents) {
        return '$' + (cents / 100).toLocaleString('en-CA', {
          minimumFractionDigits: cents % 100 ? 2 : 0,
          maximumFractionDigits: 2
        });
      }
      function update() {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var price = Number(option.dataset.price) + Number(form.dataset.basePrice);
        var compare = Math.max(Number(option.dataset.compare), Number(option.dataset.price)) +
          Math.max(Number(form.dataset.baseCompare), Number(form.dataset.basePrice));
        if (!Number.isFinite(price) || !Number.isFinite(compare)) return;
        card.querySelector('.fc-now').textContent = money(price);
        var was = card.querySelector('.fc-was');
        var saving = card.querySelector('.fc-save');
        was.hidden = saving.hidden = compare <= price;
        was.textContent = money(compare);
        saving.textContent = 'Save ' + money(compare - price);
        card.querySelector('.fc-mo strong').textContent = '$' + Math.ceil((price + 9000) / 1200) + '/mo';
        var details = form.querySelector('[data-package-mattress]');
        var url = new URL(details.href);
        url.searchParams.set('variant', option.value);
        details.href = url.href;
      }
      select.addEventListener('change', update);
      update();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
